import React, { useState, useEffect } from "react";
import ReactCodeInput from "react-code-input";
import cn from "classnames";
import { Field } from "redux-form";
import { decodeJwt } from 'jose';

import Step from "../Step";
import InputGroup from "../../utils/InputGroup";
import { Checkbox } from "../../utils/Checkbox";
import WithUserForm from "../../Register/WithUserForm";
import { ReactComponent as Warning } from "src/assets/icons/warning.svg";

import styles from "../styles.module.css";
import CTAButton from "../../utils/Button/CTAButton";

class CodeInput extends React.Component {
  codeRef = React.createRef();

  render() {
    const { input, touched, error, autoFocus } = this.props;

    const options = {
      className: cn(styles.CodeInput, { [styles.InputError]: touched && error }),
      inputStyle: {
        borderRadius: "0px",
        height: "45px",
        width: "42px",
        background: "#1A1A1A",
        border: "1px solid #C8A882",
        outline: "none",
        margin: "0 20px",
      },
    };

    return (
        <ReactCodeInput
            ref={this.codeRef}
            type="number"
            fields={3}
            autoFocus={autoFocus}
            {...options}
            {...this.props}
            {...input}
        />
    );
  }
}
const Form = ({ webLoginToken, email, phoneNumber, form, machine, sendPhoneNumberVerifyCode, sendEmailVerifyCode }) => {
  const [smsCodeKey, setSmsCodeKey] = useState(0);
  const [emailCodeKey, setEmailCodeKey] = useState(0);
  const [resendCooldown, setResendCooldown] = useState(0);

  const sendCodes = () => {
    form.reset();
    form.resetCodesErrors();
    if(!form.isVerifyCode){
      setSmsCodeKey(smsCodeKey + 1);
      sendPhoneNumberVerifyCode({
        variables: {
          webLoginToken
        },
      });
    }
    if(!form.isVerifyEmailCode) {
      setEmailCodeKey(emailCodeKey + 1);
      sendEmailVerifyCode({
        variables: {
          webLoginToken
        },
      });
    }
    setResendCooldown(30);
  }

  useEffect(() => {
    sendCodes()
  }, [])

  useEffect(() => {
    if (resendCooldown > 0) {
      const timer = setTimeout(() => setResendCooldown(resendCooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendCooldown]);


  useEffect(() => {
    if(form.isVerifyCode && form.isVerifyEmailCode){
      if(webLoginToken){
        // If the user came from web login and successfully verified both phone and email,
        // store the user token in localStorage. This token will be used to fetch the currentUser.
        window.localStorage.setItem("token", webLoginToken)
      }
      setTimeout(() => {
        machine.service.send("NEXT");
      }, 1000);
    }
  }, [form]);

  const footer = (
      <div
        style={{
          width: '90vw',
          maxWidth: '400px',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-end',
          paddingBottom: '10px'
        }}
      >
        <div style={{ width: '90%', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          {/* Center cta buttons in available space between text and footer*/}
          <CTAButton
              onClick={() => {
                if(webLoginToken){
                  // If the user came from web login, back button should send them back to web login,
                  window.location.href = `${window.location.origin}/login`;
                }
                else {
                  machine.service.send("BACK");
                }
              }}
              text={'Back'}
          />
          <CTAButton
              onClick={() => (form.isVerifyCode && form.isVerifyEmailCode) && machine.service.send("NEXT")}
              disabled={!(form.isVerifyCode && form.isVerifyEmailCode)}
              text={'Next'}
          />
        </div>
        <p
            className={` ${styles.default_text_size}`}
            style={{
              color: '#B08D57',
              lineHeight: 0.9
            }}
        >
          Having trouble? <a href="https://wa.me/447588663357" style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Contact us</a>.
        </p>
      </div>
  );
  return (
      <Step footer={footer}>
        <form onSubmit={form.handleSubmit} style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%"
        }}>
          <p
            style={{
              fontSize: 'clamp(1px, 3.9vw, 17px)',
              textAlign: 'center',
              color: 'white',
              marginBottom: '10px'
            }}
          >
            We sent a text message to {phoneNumber} <br /> and an email to  <br />{email}
            <br />
            <p className='mt-2'>Please enter both verification codes below.</p>
          </p>
          <button
              className={`${styles.resend_verify} ${(resendCooldown > 0 || (form.isVerifyCode && form.isVerifyEmailCode)) && styles.resend_disabled}`}
              onClick={sendCodes}
              type="button"
              disabled={resendCooldown > 0 || (form.isVerifyCode && form.isVerifyEmailCode)}
          >
            {resendCooldown > 0 ? `Resend in ${resendCooldown} seconds` : "Resend verification codes"}
          </button>
          <div className={styles.wrap_sms_verify}>
            <p style={{ fontSize: 'clamp(1px, 3.9vw, 17px)'}}>SMS verification code</p>
            <div className={`${styles.sms_verify} ${form.verifyCodeError && !form.isVerifyCode && styles.danger_color} ${form.isVerifyCode && styles.sms_verify_disable}`}>
              <div className="flex pl-10">
                <Field
                    normalize={(value, previousValue) => (value && value.length) > 3 ? previousValue : value}
                    name="code"
                    refKey={1}
                    key={smsCodeKey}
                    component={CodeInput}
                    disabled={form.isVerifyCode}
                />
                <InputGroup classNames={`${styles.sms_checked}`}>
                  {form.isVerifyCode && <Checkbox isChecked={true} disabled/>}
                </InputGroup>
              </div>
              {form.verifyCodeError && !form.isVerifyCode && (
                  <div className={`${styles.error_form}`}>
                    <Warning />
                    <p className={styles.warning_msg}>Your verification code failed. Please try again.</p>
                  </div>
              )}
              {!form.smsRecaptchaVerified && form.recaptchaEnabled &&(
                  <div className={`${styles.error_form}`}>
                    <Warning />
                    <p className={styles.warning_msg}>Recaptcha verification failed. Please try again.</p>
                  </div>
              )}
            </div>
          </div>

          {/* Email Verification */}
          <div className={styles.wrap_email_verify}>
            <p style={{ fontSize: 'clamp(1px, 3.9vw, 17px)'}}>Email verification code</p>
            <div className={`${styles.email_verify} ${form.verifyEmailCodeError && !form.isVerifyEmailCode && styles.danger_color} ${form.isVerifyEmailCode && styles.email_verify_disable}`}>
              <div className="flex pl-10">
                <Field
                    normalize={(value, previousValue) => (value && value.length) > 3 ? previousValue : value}
                    component={CodeInput}
                    name="emailCode"
                    refKey={2}
                    key={emailCodeKey}
                    autoFocus={false}
                    disabled={form.isVerifyEmailCode}
                />
                <InputGroup classNames={`${styles.sms_checked}`}>
                  {form.isVerifyEmailCode && <Checkbox isChecked={true} disabled/>}
                </InputGroup>
              </div>
              {form.verifyEmailCodeError && !form.isVerifyEmailCode && (
                  <div className={`${styles.error_form}`}>
                    <Warning />
                    <p className={styles.warning_msg}>Your verification code failed. Please try again.</p>
                  </div>
              )}
              {!form.emailRecaptchaVerified && form.recaptchaEnabled && (
                  <div className={`${styles.error_form}`}>
                    <Warning />
                    <p className={styles.warning_msg}>Recaptcha verification failed. Please try again.</p>
                  </div>
              )}
            </div>
          </div>
        </form>
      </Step>
  );
};

class StepConfirmation extends React.Component {
  constructor(props) {
    super(props);
    this.asyncValidate = this.asyncValidate.bind(this);
    const params = new URLSearchParams(window.location.search);

    this.state = {
      codeSent: false,
      isVerifyCode: false,
      isVerifyEmailCode: false,
      verifyCodeError: false,
      verifyEmailCodeError: false,
      smsRecaptchaVerified: true,
      emailRecaptchaVerified: true,
      webLoginToken: params.get("session")
    };
  }

  RECAPTCHA_ENABLED = process.env.REACT_APP_RECAPTCHA_ENABLED === 'true';
  resetCodesErrors = () => {
    this.setState({verifyCodeError: false, verifyEmailCodeError: false});
  };

  async asyncValidate(values, _, props) {
    const recaptchaRef = this.props.recaptchaRef;
    const isWebLogin = !!this.state.webLoginToken;

    if (!this.state.isVerifyCode) {
      if (values.code && values.code.length === 3) {

        try {
          // trigger recaptcha before sms code check
          let token = null;
          if (this.RECAPTCHA_ENABLED) {
            token = await recaptchaRef.current.executeAsync();
            recaptchaRef.current.reset();
          }
          const mutationFn = isWebLogin
              ? props.checkPhoneNumberVerifyCodeForWebLogin
              : props.checkPhoneNumberVerifyCode;

          const variables = {
            code: values.code,
            recaptchaToken: token,
            ...(isWebLogin && { webLoginToken: this.state.webLoginToken })
          };

          const mutation = await mutationFn({ variables });

          const result = isWebLogin
              ? mutation.data.checkPhoneNumberVerifyCodeForWebLogin
              : mutation.data.checkPhoneNumberVerifyCode;

          if (result) {
            this.setState({
              isVerifyCode: true,
              smsRecaptchaVerified: true,
              webLoginToken: result.token
            });
          } else {
            this.setState({ verifyCodeError: true });
          }
        } catch {
          this.setState({ smsRecaptchaVerified: false });
        }
      } else {
        this.setState({ verifyCodeError: false });
      }
    }

    if (!this.state.isVerifyEmailCode) {
      if (values.emailCode && values.emailCode.length === 3) {
        try {
          // trigger recaptcha before email code check
          let token = null;
          if (this.RECAPTCHA_ENABLED) {
            token = await recaptchaRef.current.executeAsync();
            recaptchaRef.current.reset();
          }
          const mutationFn = isWebLogin
              ? props.checkEmailVerifyCodeForWebLogin
              : props.checkEmailVerifyCode;

          const variables = {
            code: values.emailCode,
            recaptchaToken: token,
            ...(isWebLogin && { webLoginToken: this.state.webLoginToken })
          };

          const mutation = await mutationFn({ variables });

          const result = isWebLogin
              ? mutation.data.checkEmailVerifyCodeForWebLogin
              : mutation.data.checkEmailVerifyCode;

          if (result) {
            this.setState({
              isVerifyEmailCode: true,
              emailRecaptchaVerified: true,
              webLoginToken: result.token
            });
          } else {
            this.setState({ verifyEmailCodeError: true });
          }
        } catch {
          this.setState({ emailRecaptchaVerified: false });
        }
      } else {
        this.setState({ verifyEmailCodeError: false });
      }
    }
  }

  render() {
    return (
        <WithUserForm
            formRequiresAuthentication={!this.state.webLoginToken}
            asyncValidate={this.asyncValidate}
            asyncChangeFields={["code", "emailCode"]}
            isVerifyCode={this.state.isVerifyCode}
            isVerifyEmailCode={this.state.isVerifyEmailCode}
            verifyCodeError={this.state.verifyCodeError}
            verifyEmailCodeError={this.state.verifyEmailCodeError}
            recaptchaEnabled={this.RECAPTCHA_ENABLED}
            smsRecaptchaVerified={this.state.smsRecaptchaVerified}
            emailRecaptchaVerified={this.state.emailRecaptchaVerified}
            resetCodesErrors={this.resetCodesErrors}
            render={(props) => {
              const userData = props.userQuery?.data?.currentUser;
              let userEmail = userData?.email;
              let userPhone = userData?.phoneNumber;

              if(!!this.state.webLoginToken) {
                const payload = decodeJwt(this.state.webLoginToken);
                userEmail = payload.email
                userPhone = payload.phoneNumber
              }
              return (<Form webLoginToken={this.state.webLoginToken} email={userEmail} phoneNumber={userPhone} {...props} />)
            }}
        />
    );
  }
}

export default StepConfirmation;
